module.exports = __webpack_public_path__ + "static/media/footerMontgolfiere.aec433f6.png";